import { S as n, b as u } from "./useActions-BIIcXXS6.js";
import { useContext as a, useState as c, useEffect as i, useCallback as f } from "preact/hooks";
import { i as m } from "./isBot-C58Y7eiv.js";
function l(t = p) {
  const e = a(n), [o, r] = c(t(e.getState()));
  return e.onChange(t, r), i(() => () => e.clearOnChange(r), [e]), o;
}
const p = (t) => t;
function d({ from: t, size: e, pageSize: o }) {
  return m() ? {
    products: { from: t + o }
  } : {
    products: { size: e + o }
  };
}
function y(t = 24) {
  const { from: e, size: o } = l((s) => ({
    from: s.query.products?.from ?? 0,
    size: s.query.products?.size ?? 0
  })), { updateSearch: r } = u();
  return {
    loadMore: f(async () => {
      await r(d({ from: e, size: o, pageSize: t }));
    }, [e, o, t, r])
  };
}
export {
  l as a,
  d as g,
  y as u
};
